import React from 'react';

const ShippingMethod = () => {
  return <div>Shipping Method</div>;
};

export default ShippingMethod;
